import React from 'react';
import styled from 'styled-components';
import { MQ_FOR_TABLET_LANDSCAPE_UP } from 'web-ui-kit/media';
import { BodySmallLargeStyles, Header3SmallStyles, Header3LargeStyles } from 'web-ui-kit/typography';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2, _templateObject3;
/**
 * The core product information including source, name, and price.
 */


function PrimaryInfoCustomProp(_ref) {
  var _ref$product = _ref.product,
      product = _ref$product === void 0 ? {} : _ref$product;
  var _product$badge = product.badge,
      badge = _product$badge === void 0 ? '' : _product$badge,
      _product$mainType = product.mainType,
      mainType = _product$mainType === void 0 ? 'Custom Product' : _product$mainType;
  var displayName = mainType.charAt(0).toUpperCase() + mainType.substr(1).toLowerCase();
  var Container = styles.Container,
      Context = styles.Context,
      Name = styles.Name;
  return (
    /*#__PURE__*/
    React.createElement(Container, {
      "data-testid": "primary-info-custom-prop"
    },
    /*#__PURE__*/
    React.createElement(Context, null, copy.context(badge)),
    /*#__PURE__*/
    React.createElement(Name, null, displayName))
  );
}

var copy = {
  context: function context(badge) {
    return badge === 'Exact match' ? 'Exact match of your' : 'In place of your';
  }
};
var styles = {
  Container: styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    padding: 1rem;\n\n    ", " {\n      padding: 0 0 1.5rem 0;\n    }\n  "])), MQ_FOR_TABLET_LANDSCAPE_UP),
  Context: styled.p(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n    margin-bottom: 0.25rem;\n  "])), BodySmallLargeStyles),
  Name: styled.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", ";\n\n    ", " {\n      ", ";\n    }\n  "])), Header3SmallStyles, MQ_FOR_TABLET_LANDSCAPE_UP, Header3LargeStyles)
};
export default PrimaryInfoCustomProp;